const zhCN = {
    'chat.welcome': '你好，我是',
    'chat.prompt.title': '你想了解什么？',
    'chat.hot_topics': '您可能感兴趣的问题',
    'chat.input_placeholder': '请输入用户名',
    'chat.start_chat': '确认',
    'chat.direct_chat': '直接开始对话',
    'chat.direct_chat.label': '直接咨询',
    'chat.initializing': '初始化中...',
    'chat.username_required': '请输入用户名',
    'chat.init_failed': '初始化失败',
    'img.upload.fail': '图片上传失败',
    'error.handling.image': '图片处理异常',
    
    // IndependentChat 组件相关
    'video.thumbnail.generate.error': '无法生成缩略图',
    'video.load.error': '视频加载失败',
    'qa.create.error': '创建对话失败',
    'file.image.type.error': '只能上传图片文件！',
    'file.image.size.error': '图片过大，请压缩后再上传',
    'file.video.type.error': '只能上传视频文件！',
    'file.video.size.error': '视频过大，请压缩后再上传(最大100MB)',
    'file.type.error': '不支持的文件类型，请选择图片或视频文件',
    'video.upload.error': '视频上传失败',
    'video.process.error': '视频处理异常',
    'message.send.success': '消息发送成功',
    'message.send.error': '发送失败',
    'chat.agent.typing': '客服正在打字',
    'image.preview.alt': '预览图片',
    'video.thumbnail.alt': '视频缩略图',
    
    // 可拖拽关闭按钮相关
    'close.button.title.normal': '长按拖拽 | 点击结束对话',
    'close.button.title.dragging': '拖拽移动位置',
    'close.chat.confirm.title': '确认关闭聊天',
    'close.chat.confirm.content': '关闭后当前聊天将被标记为已解决，下次将开始新的对话。确定要关闭吗？',
    'close.chat.confirm.ok': '确认关闭',
    'close.chat.confirm.cancel': '取消',
    'close.chat.success': '聊天已关闭，下次将开始新的对话',
    'close.chat.error': '关闭聊天失败，请重试',
    'close.chat.final.title': '聊天已成功关闭',
    'close.chat.already.closed': '聊天已关闭',
    
    // 聊天已关闭页面相关
    'chat.closed.title': '聊天已关闭',
    'chat.closed.message': '当前聊天已结束，感谢您的使用',
    
    // 快捷问题浮窗相关
    'quick.question.title': '快捷问题',
    'quick.question.loading': '发送中...',
    'quick.question.success': '快捷回复发送成功',
    'quick.question.error': '快捷回复发送失败，请重试',
    'quick.question.send.error': '快捷回复发送失败',

    // 聊天评价相关
    'evaluation.title': '为本次对话评分',
    'evaluation.subtitle': '您的反馈有助于我们改进服务质量',
    'evaluation.prompt.message': '感谢您的使用！请为本次对话体验进行评价，您的反馈对我们很重要。',
    'evaluation.completed.prompt.message': '感谢您的评价！您的反馈对我们非常重要。',
    'evaluation.rating.1': '非常不满意',
    'evaluation.rating.2': '不满意',
    'evaluation.rating.3': '一般',
    'evaluation.rating.4': '满意',
    'evaluation.rating.5': '非常满意',
    'evaluation.feedback.placeholder': '请分享您的使用体验或建议（可选）',
    'evaluation.skip': '跳过',
    'evaluation.submit': '提交评价',
    'evaluation.submitted': '感谢您的评价！',
    'evaluation.completed': '评价已完成',
    'evaluation.your.rating': '您的评分',
    'evaluation.your.feedback': '您的反馈',
    'evaluation.thank.you': '感谢您的宝贵反馈，我们会持续改进服务！',
    'evaluation.skipped': '已跳过评价',
    'evaluation.submit.success': '评价提交成功',
    'evaluation.submit.error': '评价提交失败',
    
    // 输入框状态相关
    'input.placeholder.active': '请输入消息...',
    'input.placeholder.chatting': '请输入消息...',
    'input.placeholder.need-eval': '会话已结束，请完成评价',
    'input.placeholder.closed': '会话已结束',
    'input.placeholder.evaluation.enabled': '评价功能已启用，请等待评价消息',
    
    // 分类选择器相关
    'category.select.title': '请选择咨询类型',
    'category.select.subtitle': '选择您要咨询的问题类型，我们将为您提供更精准的服务',
    'category.deposit': '充值',
    'category.deposit.desc': '充值相关问题咨询',
    'category.withdraw': '提现',
    'category.withdraw.desc': '提现相关问题咨询',
    'category.login_otp': '登录/OTP',
    'category.login_otp.desc': '登录和验证码相关问题',
    'category.kyc': 'KYC',
    'category.kyc.desc': '身份认证相关问题',
    'category.welfare_other': '福利及其他',
    'category.welfare_other.desc': '福利活动及其他问题',
    'category.continue': '继续',
    'category.selected': '已选择：',
    'consultation.type': '咨询类型：',
    'category.switch': '切换分类',
    'category.switch.success': '分类切换成功',
    'category.switch.failed': '分类切换失败',
    
    // 文件预览相关
    'preview.click': '点击预览',
    
    // PDF预览相关
    'pdf.preview.title': 'PDF预览',
    'pdf.preview.open.new.tab': '在新页面打开',
    'pdf.preview.download': '下载',
    
    // 订单列表相关
    'order.amount.label': '金额',
    'order.channel.label': '渠道',
    'order.status.success': '成功',
    'order.status.failed': '失败',
    'order.status.processing': '处理中',
    'order.list.empty': '无订单',

    // V2 结束页
    'v2.back_to_game': '返回游戏',
    'v2.start_new_chat': '开始新对话',
    'v2.select_question': 'Please select a question',
    'v2.question_other': 'Other',
};

export default zhCN; 